<template>
  <div>
    <div class="success">
      <div class="suclog"></div>

      <h2>恭喜您成功修改了密码</h2>

      <h3>10秒后自动跳转到登录页，或您可以点击下方的完成立即前往登录</h3>
    </div>
    <el-button type="primary" class="forget_btn" @click="finishBtn()">完成</el-button>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    // 跳到登录页
    finishBtn() {
      this.$router.push({name: 'login'})
    }
  }
}
</script>

<style lang="scss" scoped>
.success {
  display: flex;
  align-items: center;
  flex-direction: column;
  .suclog {
    width: 105px;
    height: 73px;
    background-image: url(../../../assets/successlog.png);
  }
  h2 {
   width: 200px;
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 32px;
  color: #1890FF;
  margin-top: 20px;
  }
}
h3 {
  font-size: 16px;
  color: rgb(155, 155, 155);
  margin-top: 20px;
}
.forget_btn {
  width: 300px;
  margin: 50px 100px;
  letter-spacing: 10px;
  transform: translate(33px,-10px);
}
</style>
